import { useCallback } from "react";

import { useGlobalContext } from "../contexts/GlobalContext";

// Collapse state lives in GlobalContext as `isMenuOpened` (localStorage-backed).
// The navigation is ported from CRM, which expresses the same state inverted, so
// this hook adapts rather than introducing a second source of truth.
const useNavigationCollapse = () => {
  const { isMenuOpened, setGlobalContext } = useGlobalContext();

  const toggleCollapse = useCallback(
    () => setGlobalContext({ isMenuOpened: !isMenuOpened }),
    [isMenuOpened, setGlobalContext]
  );

  return { isCollapsed: !isMenuOpened, toggleCollapse };
};

export default useNavigationCollapse;
